import MuiDialogActions, { DialogActionsProps } from '@material-ui/core/DialogActions';
import Typography from './Typography';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';

type Props = DialogActionsProps & {
	onClose: React.MouseEventHandler<HTMLElement>
}

const DialogActions = withStyles(theme => ({
	root: {
		margin: 0,
		padding: theme.spacing(2)
	}
}))(({ onClose, children, classes, ...rest }: Props) => {
	if (React.Children.count(children)) {
		return (
			<MuiDialogActions className={classes.root} {...rest}>
				{children}
				{onClose && (
					<Typography variant="srOnly" component="a" onClick={onClose}>Close</Typography>
				)}
			</MuiDialogActions>
		);
	}

	if (onClose) {
		return <Typography variant="srOnly" component="a" onClick={onClose}>Close</Typography>
	}

	return null;
});

export default DialogActions;

